import { render, staticRenderFns } from "./OrderInsert.vue?vue&type=template&id=1d6bd83c&scoped=true&"
import script from "./OrderInsert.vue?vue&type=script&lang=js&"
export * from "./OrderInsert.vue?vue&type=script&lang=js&"
import style0 from "./OrderInsert.vue?vue&type=style&index=0&id=1d6bd83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6bd83c",
  null
  
)

export default component.exports